import { Button, Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import WsC from './providers/WsC';

import { ReactComponent as TrashAltSolid } from './Icoane Font Awesome/trash-alt-solid.svg'
import AlertNew from '../../commons/dialogs/AlertNew';


export default class EvaluariSefi extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            sesiuni: [],
            chestionare: [],
            popUpSalvare: true,
            sesiuneNoua: false,
            titluSesiune: '',
            openDeleteSesiune: false,
            sesiuneSelectata: {},
            alertView:false
        }
    }


    u = new Utils()
    ws = new WsC()
    ls = new LocalStorage().GetUserData()

    componentDidMount() {
        this.access()
        this.getSesiuni()
    }


    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.EsteSef === 1 ? false : true })
        }


    }


    getSesiuni = async () => {


        let q = `select s.*, (select count(*) from raspunsuri_head where id_evaluare in (select id from evaluari where id_sesiune = s.id and isnull(inactiv,0) != 1)) as completari_toate,
                             (select count(*) from raspunsuri_head where id_evaluare in (select id from evaluari where id_sesiune = s.id and isnull(inactiv,0) != 1) and statusul = @p1) as completari_finalizate from 
                             sesiuni s where isnull(s.sters,0) != 1 and s.tip = @p2 and s.baza_date = @p3`


        let _getSesiuni = this.ws.customSelect(q, { p1: 'Finalizat', p2: 'evaluare_sefi', p3: this.ls.InfoUser.Database })

        let _chestionare = this.ws.customSelect(`select u.nume as nume_utilizator,  c.* , (select count(*) from chestionare_intrebari where id_chestionar = c.id and isnull(id_parent,0) = 0) as nr_intrebari 
                                                    from chestionare c left join [${this.ls.InfoUser.Database}].[dbo].[useri] u on c.creat_de = u.id  where c.baza_date = @p1 and isnull(c.sters,0) != 1`,
            {
                p1: this.ls.InfoUser.Database,
            })


        let [getSesiuni, chestionare] = await Promise.all([_getSesiuni, _chestionare])

        if (getSesiuni.Succes && chestionare.Succes) {

            let sesiuni = [...getSesiuni.Content]

            for (let i = 0, n = sesiuni.length; i < n; i++) {

                sesiuni[i].procent_completare = Math.floor(((sesiuni[i].completari_finalizate * 100) / sesiuni[i].completari_toate || 0))

                sesiuni[i].color = sesiuni[i].procent_completare >= 80 ? 'rgb(24 165 58)' : (sesiuni[i].procent_completare < 80 && sesiuni[i].procent_completare >= 50 ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
            }

            console.log('sesiuni :>> ', sesiuni);

            this.setState({
                sesiuni: sesiuni,
                chestionare: chestionare.Content,
                popUpSalvare: chestionare.Content.length > 0 ? false : true
            })
        }

        console.log('getSesiuni :>> ', getSesiuni);
    }


    returnButton = () => {
        let rez = []




        rez.push(<div key={1}>
            <Button className='add-button-green' style={{ display: this.props.displayInsert === 1 ? 'none' : 'inline-flex' }} onClick={() => { this.setState({ sesiuneNoua: true }) }}   >
                <i className='material-icons pm-round-button-text'>add</i>
                {this.dictionary.evaluari.sesiuneNoua}
                                </Button>
        </div>)




        return rez
    }


    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            <span style={{ color: 'black', marginRight: 10 }}> {this.dictionary.evaluari.astazi}:{this.dataAzi()} </span>
        </div>)

        return rez
    }


    dataAzi = () => {


        let dataAzi = this.u.defaultData()

        if (this.dictionary.date === 'en') {
            return this.u.dataPrescurtataEng(dataAzi)
        } else {
            return this.u.dataPrescurtataRomana(dataAzi)
        }
    }


    addSesiune = async () => {

        let data = new Date()

        let luna = this.u.luni[data.getMonth()]

        let an = data.getFullYear()



        let objToInsert = {
            nume: this.state.titluSesiune,
            tip: 'evaluare_sefi',
            baza_date: this.ls.InfoUser.Database

        }

        let insertSesiune = await this.ws.insert('sesiuni', objToInsert)

        if (insertSesiune.Succes) {
            console.log('insertSesiune :>> ', insertSesiune);

            this.props.history.push(`/evaluarenouasefi/${insertSesiune.Content[0].id}/0`)
        }

    }


    goToSesiune = (s) => {
        this.props.history.push(`/evaluarisesiune/${s.id}/${s.tip}`)
    }

    openStergeSesiune = (s) => {
        this.setState({
            sesiuneSelectata: s,
            openDeleteSesiune: true
        })
    }


    deleteSesiune = async () => {
        let deleteSesiune = await this.ws.update('sesiuni', { sters: 1 }, { id: this.state.sesiuneSelectata.id })


        if (deleteSesiune.Succes) {

            this.setState({ openDeleteSesiune: false }, () => {

                this.getSesiuni()
            })
        }
    }


    render() {
        return (
            <div>

                <CustomAppBar history={this.props.history} title={this.returnButton()} appBarButtons={this.buildAppBarButtons()} />


                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />

                <AlertNew
                    open={this.state.openDeleteSesiune}
                    dialogClose={() => { this.setState({ openDeleteSesiune: false }) }}
                    title={this.dictionary.evaluari.alertStergeSesiune}
                    mesaj={this.dictionary.evaluari.alertStergeSesiuneMessage}
                    yesFunction={this.deleteSesiune}
                    deleteP={true}
                />

                {this.state.sesiuneNoua &&


                    <Grid style={{ maxWidth: 1000, margin: 'auto', marginBottom:40 }} container >

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.evaluari.evaluareManager} </h1>
                        </Grid>


                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, }}>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h4 style={{ textAlign: 'left', marginBottom: 5 }}>{this.dictionary.evaluari.creeazaDenumireEvaluare}</h4>
                                </Grid>


                                <Grid style={{ textAlign: 'left', margin: '20px 0 20px 0' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            id='chestionarNou'
                                            style={{ width: '90%' }}
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='titlu'
                                            value={this.state.titluSesiune || ''}
                                            placeholder={this.dictionary.evaluari.numeSesiune}
                                            onChange={(ev) => { this.setState({ titluSesiune: ev.target.value }) }}
                                        />




                                        <label className='inputLabelPM' htmlFor='chestionarNou'>{this.dictionary.evaluari.numeSesiune}</label>

                                    </div>
                                </Grid>



                                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Button className='add-button-green' onClick={this.addSesiune}  >
                                    {this.dictionary.evaluari.pasulUrmator}
                                </Button>
                                </Grid>

                            </Grid>
                        </Grid>

                    </Grid>

                }


                {!this.state.sesiuneNoua &&

                    <Grid style={{ maxWidth: 1000, margin: 'auto', marginBottom:40 }} container>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <h1 style={{ margin: this.state.sesiuni.length > 0 ? '80px 0 40px 17px' : '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.evaluari.evaluareManager} </h1>
                        </Grid>

                        {this.state.sesiuni.length === 0 &&

                            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>


                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5 style={{ textAlign: 'left', fontWeight: 400, fontSize: 12 }}>{this.dictionary.evaluari.nuExistaSesiuneManageri} </h5>
                                </Grid>

                                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Button className='add-button-green' onClick={() => { this.setState({ sesiuneNoua: true }) }}  >
                                      
                                    {this.dictionary.evaluari.sesiuneNoua}
                                     </Button>
                                </Grid>


                            </Grid>


                        }


                        {this.state.sesiuni.length > 0 && this.state.sesiuni.map((s, idx) => {

                            return (
                                <Grid key={idx} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <Grid className='container-sesiune' container>
                                        <Grid onClick={() => { this.goToSesiune(s) }} style={{ textAlign: 'center', fontSize: 14, fontWeight:400 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <span>{this.dictionary.evaluari.sesiuneEvaluare}</span>
                                        </Grid>
                                        <Grid onClick={() => { this.goToSesiune(s) }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <h4 style={{ textAlign: 'center', marginTop: 0 , fontSize:18, fontWeight:700}} >{s.nume}</h4>
                                        </Grid>

                                        <Grid onClick={() => { this.goToSesiune(s) }} style={{ marginTop: 20, textAlign: 'center', fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <span>{this.dictionary.evaluari.completare}</span>
                                        </Grid>

                                        <Grid onClick={() => { this.goToSesiune(s) }} style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <span className='procent-sesiune' style={{ color: s.color }}>{s.procent_completare}%</span>
                                        </Grid>

                                        <Grid onClick={() => { this.goToSesiune(s) }} style={{ textAlign: 'center', fontSize: 12, marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <span>{this.dictionary.evaluari.finalizat}:<span className='status-sesiune-evaluare' style={{fontWeight:600, color: s.finalizat !== null ? 'rgb(24 165 58)' : 'red' }}>{s.finalizat !== null ? ' DA' : ' NU'}</span> </span>
                                        </Grid>


                                        <div className='delete-sesiune'>
                                            <TrashAltSolid onClick={() => { this.openStergeSesiune(s) }} style={{ marginRight: 0, width: 18, height: 18, color: 'rgb(252 62 70)' }} />
                                        </div>
                                    </Grid>


                                </Grid>
                            )

                        })}

                        {this.state.sesiuni.length > 0 &&
                            < Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Button className='add-button-green' onClick={() => { this.setState({ sesiuneNoua: true }) }}  >
                                {this.dictionary.evaluari.sesiuneNoua}
                             </Button>
                            </Grid>
                        }



                        {this.state.popUpSalvare &&

                            <div style={{ display: 'flex', justifyContent: "space-between", backgroundColor: 'rgb(254 193 53)', borderRadius: 30, padding: 10, marginBottom: 20, textAlign: 'left', width: '100%' }}>
                                <div>
                                    <i style={{ fontSize: 18, verticalAlign: 'middle' }} className='material-icons'>error</i> <span style={{ fontSize: 12, fontWeight: 500 }}>
                                    {this.dictionary.evaluari.nuAiChestionarSalvatSistem}  <span onClick={this.goToChestionare} style={{ textDecoration: 'underline', cursor: 'pointer' }}>{this.dictionary.evaluari.clickAici}</span> {this.dictionary.evaluari.pentruACreaUnChestionarAcum}</span>
                                </div>
                                <div>
                                    <i style={{ fontSize: 18, verticalAlign: 'bottom', cursor: "pointer" }} onClick={() => { this.setState({ popUpSalvare: false }) }} className='material-icons'>clear</i>
                                </div>

                            </div>
                        }

                    </Grid>


                }


            </div >
        );
    }
}